function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkInProgressIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.58,213.15c-1-6.19-2.19-12.27-3.49-18.19C465.49,146.77,441,95.64,393,76.18,337.78,53.8,259.4,60,210,103.71c-38,33.6-115,53.88-158,104.82C7.43,261.34-1.88,360.31,56,400.26c41.17,28.41,92.07,6,137.92-3.39,26.11-5.34,48.71-2.32,74.45,0,44.73,4,91.06,7,136.17-3,22.28-5,42.09-14.06,54.65-34.72C485.57,315.7,487.39,261,479.58,213.15Z",
    style: {
      fill: "#EFDECB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.58,213.15c-1-6.19-2.19-12.27-3.49-18.19C465.49,146.77,441,95.64,393,76.18,337.78,53.8,259.4,60,210,103.71c-38,33.6-115,53.88-158,104.82C7.43,261.34-1.88,360.31,56,400.26c41.17,28.41,92.07,6,137.92-3.39,26.11-5.34,48.71-2.32,74.45,0,44.73,4,91.06,7,136.17-3,22.28-5,42.09-14.06,54.65-34.72C485.57,315.7,487.39,261,479.58,213.15Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.7,25a16.25,16.25,0,0,0-1.12,6.19c0,3.66-8.78,0-12.07,4.75s.37,7.68-4,9.14-4.75-2.19-10.23-1.83-4.76,5.49-6.58,6.95-1.83.73-5.85,1.1-4.76,3.29-4.76,3.29h96.15s2.8-8.4-.91-13.19",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.57,38.28c-4-1.17-4.68,2.39-9,.55s-5-5.25-6.21-8.9c-.13-.41-.27-.83-.42-1.25-4.33-12-20.95-15.33-28.09-7.25",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72,50.55s2-6.16-2.9-10.69-10-2-11.41,0-1.44,5.8-3.8,6.16-1.81-4-6.88-2.9-3.08,6.16-5.43,7.25-2.35-2.9-5.61-1.63-3.08,3.62-3.08,3.62",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.71,38.25a9.16,9.16,0,0,0-9.27-.81c-5.24,2.42-2.82,7.46-5.24,8.67s-3.63-.2-6.65,1.21-2.82,3.42-2.82,3.42",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.71,144.55H467.8s3.66-11-2.92-15-6.58,1.46-11.7-.73c-4.23-1.81-5-5.25-6.2-8.9-.14-.41-.28-.83-.43-1.25a16,16,0,0,0-1.58-3.24",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.5,110.68c-9.54-7-25.34-4.37-25.34,10.47,0,3.66-8.77,0-12.06,4.75s.36,7.68-4,9.14-4.75-2.19-10.24-1.83-4.75,5.49-6.58,6.95-1.83.73-5.85,1.1-4.75,3.29-4.75,3.29H423",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.3,140.55s2-6.16-2.89-10.69-10-2-11.41,0-1.45,5.8-3.8,6.16-1.81-4-6.88-2.9-3.08,6.16-5.43,7.25-2.36-2.9-5.62-1.63-3.07,3.62-3.07,3.62",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.3,128.25a9.16,9.16,0,0,0-9.27-.81c-5.25,2.42-2.83,7.46-5.25,8.67s-3.62-.2-6.65,1.21-2.82,3.42-2.82,3.42",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.36,159.77c-5-5.9-16.32-5.18-16.32,4.35,0,2.1-5,0-6.92,2.73s.21,4.4-2.31,5.24-2.73-1.26-5.88-1.05-2.72,3.15-3.77,4-1.05.42-3.36.63a2.84,2.84,0,0,0-2.72,1.89h55.17s2.1-6.3-1.68-8.6-3.78.83-6.71-.42c-2.43-1-2.88-3-3.56-5.11",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.2,175.25a6.15,6.15,0,0,0-1.66-6.13c-2.8-2.6-5.71-1.14-6.54,0s-.83,3.33-2.18,3.53-1-2.28-3.95-1.66-1.77,3.53-3.12,4.16-1.35-1.67-3.22-.94-1.77,2.08-1.77,2.08",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.28,168.19a5.26,5.26,0,0,0-5.32-.46c-3,1.39-1.62,4.28-3,5s-2.08-.11-3.81.7-1.62,2-1.62,2",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.84,122.54a5.08,5.08,0,0,0-2.9-.62c-3.15.21-2.73,3.15-3.78,4s-1,.42-3.35.63a2.86,2.86,0,0,0-2.73,1.89H99.25s1.36-4.08-.08-6.88",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.57,119.82c-3.77-2.3-3.77.84-6.71-.42-2.43-1-2.88-3-3.56-5.1l-.24-.72c-3.19-8.86-18-9.47-18,1.42,0,2.1-5,0-6.92,2.73s.21,4.4-2.31,5.24",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.21,126.13A6.17,6.17,0,0,0,87.55,120c-2.81-2.6-5.72-1.14-6.55,0s-.83,3.32-2.18,3.53-1-2.28-3.95-1.66S73.1,125.4,71.75,126s-1.35-1.67-3.22-.94-1.76,2.08-1.76,2.08",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.29,119.07a5.28,5.28,0,0,0-5.33-.46c-3,1.39-1.62,4.28-3,5s-2.09-.11-3.82.7-1.62,2-1.62,2",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.11,174.84V419a24.48,24.48,0,0,1-24.48,24.48H183.51A24.48,24.48,0,0,1,159,419V174.84c0-.38,0-.75,0-1.12a24.47,24.47,0,0,1,24.45-23.36h48.55l.05.18c1.44,5.17,4.74,8.53,8.41,8.53h2.11c3.65,0,7-3.36,8.4-8.53l.05-.18h48.55a24.47,24.47,0,0,1,24.45,23.36C324.1,174.09,324.11,174.46,324.11,174.84Z",
    style: {
      fill: "#EFDECB",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.08,173.72h-165a24.47,24.47,0,0,1,24.45-23.36h48.55l.05.18c1.44,5.17,4.74,8.53,8.41,8.53h2.11c3.65,0,7-3.36,8.4-8.53l.05-.18h48.55A24.47,24.47,0,0,1,324.08,173.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.61,240V209H331.8V169.25a24.48,24.48,0,0,0-24.48-24.49H175.82a24.48,24.48,0,0,0-24.49,24.49v267.2a24.48,24.48,0,0,0,24.49,24.49h131.5a24.48,24.48,0,0,0,24.48-24.49v-170h2.81V248.1H331.8V240Zm-10.5,179a24.48,24.48,0,0,1-24.48,24.48H183.51A24.48,24.48,0,0,1,159,419V174.84a24.48,24.48,0,0,1,24.48-24.48h48.55l.05.18c1.43,5.17,4.74,8.53,8.4,8.53h2.11c3.67,0,7-3.36,8.41-8.53l.05-.18h48.55a24.48,24.48,0,0,1,24.48,24.48Z",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,148.14H180.1a25.93,25.93,0,0,0-25.93,25.93V431.63a25.93,25.93,0,0,0,25.93,25.93H303A25.93,25.93,0,0,0,329,431.63V174.07A25.93,25.93,0,0,0,303,148.14ZM324.11,419a24.48,24.48,0,0,1-24.48,24.48H183.51A24.48,24.48,0,0,1,159,419V174.84a24.48,24.48,0,0,1,24.48-24.48h48.55l.05.18c1.43,5.17,4.74,8.53,8.4,8.53h2.11c3.67,0,7-3.36,8.41-8.53l.05-.18h48.55a24.48,24.48,0,0,1,24.48,24.48Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.36,151.53a2.3,2.3,0,1,0-2.3,2.3A2.3,2.3,0,0,0,243.36,151.53Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7,160.34c0,2.33-2.61,3.16-2.62,4.94v.12h2.53v.78h-3.38v-.66c0-2.49,2.61-3,2.61-5.15,0-.79-.27-1.21-.9-1.21s-.91.45-.91,1.14V161h-.8v-.63c0-1.18.54-2,1.73-2S173.7,159.16,173.7,160.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.92,160.33v.2a1.55,1.55,0,0,1-.94,1.59,1.52,1.52,0,0,1,.94,1.59v.6c0,1.18-.55,1.95-1.74,1.95s-1.73-.77-1.73-1.95v-.53h.8v.58c0,.7.29,1.12.91,1.12s.9-.41.9-1.19v-.6c0-.76-.32-1.12-1-1.14h-.46v-.78h.5a.92.92,0,0,0,.93-1.05v-.36c0-.79-.28-1.2-.9-1.2s-.91.43-.91,1.13v.39h-.8v-.35c0-1.18.55-1.94,1.73-1.94S177.92,159.15,177.92,160.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.59,160.91V162h-.83v-1.07Zm0,4.2v1.07h-.83v-1.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.33,161.61a1.23,1.23,0,0,1,1.14-.64c1,0,1.44.73,1.44,1.83v1.51c0,1.18-.57,1.95-1.75,1.95s-1.73-.77-1.73-1.95v-.52h.81v.57c0,.7.29,1.12.9,1.12s.91-.42.91-1.12v-1.5c0-.69-.29-1.11-.91-1.11a.84.84,0,0,0-.87.83v.17h-.8l.21-4.28h3v.77h-2.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.19,160.32v.14h-.8v-.2c0-.69-.29-1.1-.92-1.1s-.93.42-.93,1.25v1.73a1.24,1.24,0,0,1,1.24-.83c1,0,1.44.72,1.44,1.83v1.17c0,1.18-.59,1.95-1.77,1.95s-1.77-.77-1.77-1.95v-3.94c0-1.22.55-2,1.77-2S188.19,159.14,188.19,160.32Zm-2.65,2.89v1.15c0,.7.28,1.12.91,1.12s.92-.42.92-1.12v-1.15c0-.7-.3-1.12-.92-1.12S185.54,162.51,185.54,163.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.23,
    y: 160.66,
    width: 2.18,
    height: 5.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.13,
    y: 159.57,
    width: 2.18,
    height: 6.54,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.04,
    y: 158.79,
    width: 2.18,
    height: 7.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.94,
    y: 157.45,
    width: 2.18,
    height: 8.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.08,166H295v-8h13.07Zm-12.35-.72h11.62v-6.54H295.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.82,
    y: 159.48,
    width: 6.9,
    height: 4.95,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.62,
    y: 161.02,
    width: 1.64,
    height: 1.88,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.21,164.22a.51.51,0,0,1-.24-.07c-2.66-1.58-4.42-.12-4.5-.05a.49.49,0,0,1-.64-.74c.1-.08,2.34-2,5.63-.05a.48.48,0,0,1,.17.67A.49.49,0,0,1,290.21,164.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.2,162.58a.55.55,0,0,1-.25-.07c-3.85-2.29-6.43-.08-6.46-.06a.49.49,0,0,1-.69,0,.5.5,0,0,1,.05-.69s3.15-2.7,7.6-.05a.49.49,0,0,1,.17.67A.5.5,0,0,1,291.2,162.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.09,160.68a.59.59,0,0,1-.25-.07c-4.87-2.9-8.11-.17-8.24-.05a.5.5,0,0,1-.69-.05.49.49,0,0,1,0-.69s3.89-3.32,9.39,0a.49.49,0,0,1-.25.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.75,165a1.23,1.23,0,1,1-1.23-1.22A1.23,1.23,0,0,1,288.75,165Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.5,235.83l.88-5.67a17.93,17.93,0,0,0,4-1.66l6.53,4.77,5.1-5.09-4.77-6.53a17.71,17.71,0,0,0,1.65-4l8-1.24v-7.21l-8-1.24a17.45,17.45,0,0,0-1.65-4L133,197.4l-5.1-5.1-6.53,4.77a17.93,17.93,0,0,0-4-1.66l-1.24-8h-7.21l-1.25,8a18.33,18.33,0,0,0-4,1.66l-.9-.66M100.84,195l-3.7-2.7-5.09,5.1,4.77,6.53a17.93,17.93,0,0,0-1.66,4l-8,1.24v7.21l8,1.24a18.2,18.2,0,0,0,1.66,4l-4.77,6.53,5.09,5.09,6.53-4.77a18.33,18.33,0,0,0,4,1.66l1.25,8h7.21M110,223.9a11.39,11.39,0,1,1,4.31.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.72,238.44v-4.83l-5.35-.83a12.49,12.49,0,0,0-1.11-2.69l3.19-4.36L84,222.31l-4.37,3.2A11.66,11.66,0,0,0,77,224.4l-.84-5.35H71.33l-.83,5.35a11.55,11.55,0,0,0-2.69,1.11l-4.37-3.2L60,225.73l3.19,4.36a12,12,0,0,0-1.1,2.69l-5.35.83v4.83l5.35.83a12.09,12.09,0,0,0,1.1,2.68L60,246.32l3.41,3.41,4.37-3.19a12.49,12.49,0,0,0,2.69,1.11l.83,5.35h4.82l.84-5.35a12.62,12.62,0,0,0,2.68-1.11L84,249.73l3.41-3.41L84.26,242a12.62,12.62,0,0,0,1.11-2.68Zm-14-9.45a7.63,7.63,0,1,1-5.94,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.58,366.09l2.73-7.62L364,355l-4.92,6.43a18.07,18.07,0,0,0-4.31-.47l-3.45-7.31-6.92,2,1.07,8a17.59,17.59,0,0,0-3.38,2.73l-7.61-2.74L331,370l6.43,4.92a18.07,18.07,0,0,0-.47,4.31l-7.31,3.45,2,6.92,8-1.06a17.92,17.92,0,0,0,2.73,3.37l-2.74,7.62L346,403l4.92-6.43a18.1,18.1,0,0,0,4.32.47l3.44,7.31,6.92-2-1.06-8a17.53,17.53,0,0,0,3.37-2.73l7.62,2.74L379,388l-6.43-4.92a17.57,17.57,0,0,0,.47-4.31l7.32-3.45-2-6.92-8,1.06c-.18-.3-.38-.59-.58-.88m-23.28,18a11.4,11.4,0,1,1,4.76,3.22",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.93,347.59l4.23,2.31,3.3-4.3a12.22,12.22,0,0,0,2.88.31l2.31,4.9,4.63-1.37-.71-5.36a11.87,11.87,0,0,0,2.25-1.83l5.1,1.83,2.31-4.23-4.3-3.29a11.85,11.85,0,0,0,.31-2.89l4.9-2.31-1.36-4.63-5.37.71a12.21,12.21,0,0,0-1.82-2.25l1.83-5.1-4.24-2.31-3.29,4.3a11.85,11.85,0,0,0-2.89-.31l-2.31-4.9-4.62,1.36.71,5.37a12,12,0,0,0-2.26,1.82l-5.1-1.83-2.31,4.24,4.3,3.29a12.36,12.36,0,0,0-.31,2.89l-4.9,2.31,1.37,4.62,5.36-.71a11.62,11.62,0,0,0,1.83,2.26Zm12.46-6.45a7.63,7.63,0,1,1,4.48-3.65,8,8,0,0,1-.74,1.12",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 461,
    x2: 474,
    y2: 461,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Apps--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.12,
    y: 191.2,
    width: 34.26,
    height: 34.26,
    rx: 5.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.9,198.38V214s-11.18-8.63-9.75,1.12c.68,4.56,11,2.56,11,2.56V204.27a24.13,24.13,0,0,0,4.69-1.11c2.87-1,6.23-4.8,6.23-4.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.58,
    y: 300.86,
    width: 34.26,
    height: 34.26,
    rx: 5.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.5,
    y: 309.89,
    width: 23.95,
    height: 15.37,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "228.5 309.89 240.28 319.87 252.28 310.02",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.5,
    y1: 325.25,
    x2: 237.08,
    y2: 317.47,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.45,
    y1: 325.25,
    x2: 243.47,
    y2: 317.47,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 191.2,
    width: 34.26,
    height: 34.26,
    rx: 5.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.43,
    cy: 208.33,
    r: 10.98,
    transform: "translate(-64.19 252.95) rotate(-42.82)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.43,
    cy: 208.33,
    r: 9.25,
    transform: "translate(-6.97 406.58) rotate(-69.34)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.55,203.45a3.47,3.47,0,1,1-3.47-3.47A3.47,3.47,0,0,1,290.55,203.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.12,
    y: 247.72,
    width: 34.26,
    height: 34.26,
    rx: 5.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.65 264.92 182.39 253.23 182.39 276.62 202.65 264.92",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 357.39,
    width: 34.26,
    height: 34.26,
    rx: 5.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.6,363.73c-6.93,0-12.56,4.5-12.56,10,0,3.58,2.36,6.72,5.9,8.5l-2.13,5.31,6.72-3.91a15.53,15.53,0,0,0,2.07.14c6.94,0,12.57-4.49,12.57-10S297.54,363.73,290.6,363.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.3,
    y: 247.72,
    width: 34.26,
    height: 34.26,
    rx: 5.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.43,
    cy: 264.85,
    r: 11.81,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "286.71 269.69 290.44 264.85 290.44 256.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.12,
    y: 299.63,
    width: 34.26,
    height: 34.26,
    rx: 5.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.7,315.64a.46.46,0,0,1,.51-.08l5,2.51,4.93-6.9a.45.45,0,0,1,.59-.13l3.9,2.23v-6.22H178.8v16.14Zm-3.4-7.5a2.68,2.68,0,1,1-2.68,2.68A2.68,2.68,0,0,1,183.3,308.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.62,314.3l-4-2.27-4.92,6.88a.45.45,0,0,1-.57.14l-5.07-2.53-8.29,7.92v2.7h22.84V314.31Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--crane-2--inject-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "278.94 191.2 290.71 180.19 290.71 92.99",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.71,
    y1: 180.19,
    x2: 303.5,
    y2: 191.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.54,80.56v5.79l2.32,4.05A4.88,4.88,0,0,1,291,95.28h0a4.89,4.89,0,0,1-4.88-4.88V86.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.81,
    y: 69.44,
    width: 9.76,
    height: 10.84,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.2,
    y: 54.9,
    width: 16.98,
    height: 21.77,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.32,
    y: 65.83,
    width: 26.92,
    height: 6.68,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.69 65.83 289.84 65.83 284.39 72.01 284.96 72.51 287.8 72.51 293.69 65.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.43 65.83 280.32 68.22 280.32 72.51 280.39 72.51 286.29 65.83 282.43 65.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.1 65.83 297.25 65.83 291.8 72.01 292.37 72.51 295.21 72.51 301.1 65.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.24 67.26 307.24 65.83 304.65 65.83 299.2 72.01 299.78 72.51 302.61 72.51 307.24 67.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.31,
    y1: 54.52,
    x2: 293.31,
    y2: 41.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "494.58 41.09 286.51 41.09 286.51 33.24 322.11 18.15 494.58 18.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.11 41.09 322.11 18.15 345.65 41.09 345.65 18.15 322.11 41.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.62 41.09 345.62 18.15 369.15 41.09 369.15 18.15 345.62 41.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.12 41.09 369.12 18.15 392.66 41.09 392.66 18.15 369.12 41.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.63 41.09 392.63 18.15 416.16 41.09 416.16 18.15 392.63 41.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.13 41.09 416.13 18.15 439.67 41.09 439.67 18.15 416.13 41.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.64 41.09 439.64 18.15 463.17 41.09 463.17 18.15 439.64 41.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.14 41.09 463.14 18.15 486.68 41.09 486.68 18.15 463.14 41.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--crane-1--inject-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "202.02 299.4 190.25 288.39 190.25 132.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190.25,
    y1: 288.39,
    x2: 177.46,
    y2: 299.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.41,120.57v5.79l-2.31,4a4.88,4.88,0,0,0,4.88,4.88h0a4.88,4.88,0,0,0,4.87-4.88v-4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.39,
    y: 109.45,
    width: 9.76,
    height: 10.84,
    transform: "translate(374.53 229.74) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.77,
    y: 94.91,
    width: 16.98,
    height: 21.77,
    transform: "translate(374.53 211.59) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.72,
    y: 105.84,
    width: 26.92,
    height: 6.68,
    transform: "translate(374.35 218.36) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.26 105.84 191.12 105.84 196.57 112.02 196 112.52 193.16 112.52 187.26 105.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.53 105.84 200.64 108.23 200.64 112.52 200.57 112.52 194.67 105.84 198.53 105.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.86 105.84 183.71 105.84 189.16 112.02 188.59 112.52 185.75 112.52 179.86 105.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.72 107.28 173.72 105.84 176.3 105.84 181.75 112.02 181.18 112.52 178.34 112.52 173.72 107.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 187.65,
    y1: 94.53,
    x2: 187.65,
    y2: 81.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "10.38 81.1 194.45 81.1 194.45 73.25 158.84 58.16 10.38 58.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.84 81.1 158.84 58.16 135.31 81.1 135.31 58.16 158.84 81.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.34 81.1 135.34 58.16 111.8 81.1 111.8 58.16 135.34 81.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.83 81.1 111.83 58.16 88.3 81.1 88.3 58.16 111.83 81.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.33 81.1 88.33 58.16 64.79 81.1 64.79 58.16 88.33 81.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.83 81.1 64.83 58.16 41.29 81.1 41.29 58.16 64.83 81.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.32 81.1 41.32 58.16 17.78 81.1 17.78 58.16 41.32 81.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.57,390.18c2.36,1,8.13.9,8.14.9s-1.24-3.78-1.35-4c-1.27-2.65-5.28-7-8.54-6.59a3.9,3.9,0,0,0-3.12,4.89C49.24,387.62,51.56,389.3,53.57,390.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.56,406.91c2.45.36,7.6-1.13,8-1.26a70.41,70.41,0,0,0,3.13,8.66c.71,1.64,1.48,3.27,2.26,4.89-.47-.68-.89-1.3-1-1.38-1.92-2.22-7-5.38-10-4.1a3.89,3.89,0,0,0-1.73,5.54c1.12,2,3.8,3,6,3.36s6.62-.87,7.79-1.2c.31.62.61,1.25.92,1.86,1.49,3,3,5.94,4.38,8.88.49,1,.93,2.08,1.38,3.12-.42-.61-.78-1.12-.84-1.19-1.92-2.22-6.94-5.39-10-4.1a3.9,3.9,0,0,0-1.73,5.53c1.12,2,3.8,3,6,3.36s6.19-.75,7.58-1.14c.43,1.08.86,2.16,1.22,3.23.23.73.51,1.42.7,2.17s.41,1.46.61,2.19c.34,1.4.69,2.85,1,4.23.21,1,.39,1.88.58,2.8-.47-1-1.44-3.06-1.54-3.22-1.57-2.48-6-6.37-9.24-5.56a3.89,3.89,0,0,0-2.54,5.21c.79,2.18,3.29,3.58,5.39,4.22,2.31.71,7.42.06,8.06,0,.31,1.53.59,3,.84,4.43.18,1,.35,2,.5,3h2.05c-.19-1.08-.4-2.2-.63-3.37-.31-1.55-.67-3.21-1-4.9a43.52,43.52,0,0,0,4.5-2.12c1.69,1.82,6,4,6.56,4.23-.59,1.45-1.17,2.84-1.75,4.16l-.88,2h2.16l.52-1.25c.6-1.46,1.22-3,1.83-4.66.62.13,5.69,1.16,8.05.62,2.14-.48,4.73-1.69,5.69-3.81a3.89,3.89,0,0,0-2.15-5.38c-3.12-1.05-7.88,2.5-9.63,4.86-.1.14-1,1.78-1.63,2.82.25-.66.5-1.31.75-2,.5-1.35,1-2.72,1.45-4.19.21-.72.43-1.45.65-2.18s.39-1.52.59-2.28c.42-1.78.76-3.61,1.07-5.45,1.19.43,5.43,1.91,7.63,1.75s4.94-1,6.21-2.9a3.91,3.91,0,0,0-1.31-5.65c-2.93-1.51-8.17,1.27-10.25,3.35-.13.13-1.46,1.78-2.17,2.7.17-1.11.35-2.22.49-3.35.41-3.26.72-6.57,1-9.88.1-1,.21-2,.31-3,.42.16,5.43,2,7.9,1.85,2.19-.15,4.93-1,6.2-2.9a3.9,3.9,0,0,0-1.31-5.65c-2.92-1.51-8.17,1.27-10.25,3.34-.16.16-2.06,2.55-2.52,3.18.24-2.23.49-4.44.83-6.61a69.63,69.63,0,0,1,1.9-8.69c.19.07,5.41,2,7.94,1.87,2.18-.16,4.93-1,6.2-2.91a3.9,3.9,0,0,0-1.31-5.65c-2.92-1.5-8.17,1.28-10.25,3.35-.16.16-2.21,2.73-2.55,3.22,0-.16.08-.34.13-.5a50.16,50.16,0,0,1,3.44-8.23c.75-1.46,1.55-2.82,2.35-4.12.94.46,5.23,2.55,7.52,2.64s5-.41,6.48-2.21a3.88,3.88,0,0,0-.68-5.75c-2.74-1.82-8.25.36-10.55,2.2-.13.1-1.29,1.25-2.12,2.1.38-.58.75-1.19,1.12-1.74,1.37-2.07,2.76-3.89,4-5.48.72-.91,1.38-1.71,2-2.45,1.16,0,5.81-.16,7.85-1.12s4.26-2.67,4.74-4.94a3.9,3.9,0,0,0-3.26-4.8c-3.27-.35-7.16,4.13-8.35,6.82-.11.23-1.31,4-1.25,4h.07c-.62.7-1.27,1.47-2,2.31-1.28,1.57-2.71,3.36-4.14,5.41a69.11,69.11,0,0,0-4.29,6.84,51,51,0,0,0-3.67,8.25l0,.11c0-1,0-3.67,0-3.87-.38-2.92-2.82-8.33-6.06-8.92A3.89,3.89,0,0,0,95,395.17c-.19,2.31,1.49,4.63,3.13,6.09,1.85,1.65,7,3.25,7.38,3.38a68.48,68.48,0,0,0-2.17,8.93c-.31,1.77-.57,3.55-.81,5.34,0-.83,0-1.58,0-1.68-.37-2.92-2.82-8.33-6-8.93A3.9,3.9,0,0,0,91.94,412c-.19,2.31,1.49,4.63,3.12,6.09s6,2.94,7.16,3.3c-.09.69-.18,1.38-.26,2.07-.4,3.3-.77,6.6-1.25,9.82-.16,1.13-.37,2.25-.57,3.36,0-.74,0-1.36,0-1.46-.37-2.91-2.82-8.32-6-8.92a3.89,3.89,0,0,0-4.49,3.66c-.19,2.32,1.48,4.64,3.12,6.1s5.58,2.79,6.95,3.23c-.24,1.14-.48,2.27-.76,3.36-.21.74-.36,1.46-.62,2.2l-.69,2.16c-.5,1.36-1,2.76-1.52,4.08-.35.91-.7,1.78-1.05,2.65.18-1.13.48-3.34.48-3.53a15.09,15.09,0,0,0-2-7.36,4.14,4.14,0,0,0,0-.86,3.89,3.89,0,0,0-4.76-3.3c-3.18.84-5.2,6.43-5.35,9.36,0,.17.11,2.06.2,3.25-.16-.69-.31-1.36-.48-2.07-.34-1.41-.71-2.8-1.11-4.3l-.66-2.18c-.2-.73-.51-1.48-.77-2.22-.62-1.72-1.35-3.43-2.11-5.14,1.23-.3,5.59-1.41,7.34-2.75s3.58-3.52,3.57-5.85a3.89,3.89,0,0,0-4.21-4c-3.27.35-6.11,5.56-6.7,8.44,0,.18-.23,2.29-.32,3.46-.47-1-.93-2.05-1.43-3.07-1.47-2.95-3-5.88-4.59-8.82-.48-.89-.94-1.8-1.41-2.7.44-.1,5.64-1.3,7.6-2.81,1.74-1.33,3.59-3.52,3.57-5.84a3.88,3.88,0,0,0-4.2-4c-3.27.36-6.11,5.57-6.71,8.45,0,.21-.32,3.25-.35,4-1-2-2-4-3-6a66.71,66.71,0,0,1-3.21-8.29c.2-.05,5.64-1.29,7.65-2.83,1.74-1.33,3.59-3.52,3.57-5.84a3.91,3.91,0,0,0-4.21-4c-3.27.36-6.11,5.57-6.7,8.45,0,.22-.34,3.5-.35,4.09,0-.16-.12-.33-.17-.49a50.1,50.1,0,0,1-1.67-8.76c-.18-1.63-.26-3.21-.31-4.74,1-.12,5.77-.75,7.72-1.94s4-3.11,4.2-5.42a3.9,3.9,0,0,0-3.75-4.42c-3.29,0-6.68,4.86-7.59,7.65-.05.16-.38,1.76-.6,2.93,0-.7,0-1.41,0-2.07,0-2.49.16-4.77.32-6.79.09-1.14.2-2.18.32-3.14,1-.66,4.76-3.34,5.93-5.26s2.07-4.58,1.22-6.74a3.9,3.9,0,0,0-5.36-2.21c-2.92,1.52-3.69,7.4-3.21,10.3,0,.25,1.15,4.09,1.2,4.06l.06,0c-.13.93-.26,1.92-.38,3-.2,2-.4,4.3-.46,6.8a67.55,67.55,0,0,0,.19,8.07,50.74,50.74,0,0,0,1.49,8.9s0,.07,0,.11c-.52-.82-2-3-2.18-3.2-1.92-2.22-6.94-5.38-10-4.1a3.89,3.89,0,0,0-1.73,5.53C50.71,405.59,53.39,406.6,55.56,406.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,391.45c.05,0,1.05-3.84,1.09-4.09.4-2.91-.53-8.77-3.49-10.2a3.9,3.9,0,0,0-5.3,2.35c-.79,2.18.21,4.86,1.41,6.7C107.1,388.37,112,391.45,112,391.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.3,257.62s-4.5,6.51-4.33,7.35,1.24.91.19,2.09-3.22,3.38-3.34,4.58a4.24,4.24,0,0,0,1.11,2.58s-1.08,5.23-.73,6.44,4.28,2,4.28,2l-1.05,3.84,11.32,3.24,1.94-6.79,6.73-20.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.55,256.81c-.72-.14-3.74-2.32-8.14-3.11s-6.1,1-6.61,2.83-1.51.89-.23,2.13-.95,2.35-.95,2.35a3.2,3.2,0,0,1-.45,2c-.63,1.33,1.32,3.74,1.32,3.74a10.91,10.91,0,0,0-.85,2.82c0,.79.68,1.17,1.29.77s1.82-2.94,1.85-1.69-1.27,10.15-.51,11.51,5.94,2.58,7.42,2.8,6.18-4.66,8.65-7.68,4.09-9.3,3.27-12.71A8.3,8.3,0,0,0,425.55,256.81Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.61,268.14a37.14,37.14,0,0,1-1,4c-.54,1.52-1.86,2-1.42,2.92s1.06.76,2-.25a10.64,10.64,0,0,0,2.23-4.15C413.62,269.43,414.36,266.84,411.61,268.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.56,273a25.05,25.05,0,0,0,5.95,3.47,19.3,19.3,0,0,0,9.49,1.08,4.58,4.58,0,0,0,2.67-1.23c.82-1,.82-3.08.82-3.69s3.42-6.61.55-12.56-15.32-9.79-17.58-9.38-6.35,6.56-6.35,6.56-4.69.88-4.71,2.91c0,2.53,2.56,3.3,3.45,5.69A17.48,17.48,0,0,0,412.56,273Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.57,258.66s4.72-5.19,5.66-5.67c.69-.34,3.62-.06,6.71,1.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.21,286.39,402,292.26s8.08-2.35,12.49-2.35a59.87,59.87,0,0,1,9.25.89l-2.06-5.73S410.5,283.89,405.21,286.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.61,363.84a55.65,55.65,0,0,1-.44,7.34c-.44,2.2-3.37,5.58-4.55,6.17s-2.64.73-2.94,0-.73-.44-.29-4.26,2.06-11.16,2.06-11.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.64,359.14l-1,4.7a11.39,11.39,0,0,1-3.81.14,2.91,2.91,0,0,1-2.35-2.05l.44-4.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.92,295.94s2.06,12.48,3.38,21.73a124.23,124.23,0,0,1,1.31,22.47c-.3,4.41-2.06,18.56-2.65,19.58s-4.55,1.47-6.16.74-2.35-1.62-2.35-4.41,1.46-28.83,1.46-28.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.19,457.18a3.56,3.56,0,0,0-1.66.42c-.87.47-4.65,1.5-7.08,2.36-3.8,1.35-6.76.63-6.46,1.62s6.23,3,9.66,3,5.08-.8,6.72-.77.43.82,3.15,1.13,3.62.32,4.57-1.17,1.49-1.87,1.19-3.76V460a3.49,3.49,0,0,0-3.49-2.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.41,455.36a2.62,2.62,0,0,0-1.43.4c-.75.47-4,1.46-6.09,2.31-3.27,1.32-5.87.44-5.57,1.52s3.8,2.54,6.79,2.71a24.81,24.81,0,0,0,4.84-.18c3.22-.18,1.17,1,2.33,1.43a7.76,7.76,0,0,0,2.51.36c3.4.18,3.82.45,4.6-1.12s1.23-2,.91-4v-.06a3.58,3.58,0,0,0-3.14-3.19Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.93,348.86s.59,20.56.59,27.46,1.76,38.09,4.11,49.4A237.67,237.67,0,0,1,403.3,455c0,1.76-.58,2.2.59,3.37s5.58,3.38,7.2,2.65,2.49-3.53,2.49-3.53,0-15.27.45-25.26-.3-23.05-.3-23.05,5.73,26.43,7.34,31.72,2.94,14.88,3.24,16.78,1.58,2,3.22,2c2,0,4.41-.26,5.29-1.73s-1-16.89-1-23.05S427,390.42,427.39,381s3.23-25.7,2.35-30.55a54.18,54.18,0,0,1-.88-8.71S398.6,338.28,394.93,348.86Z",
    style: {
      fill: "#5e5e5e",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.15,253s.57-1,1.42-2.69a11.09,11.09,0,0,0,.7-4.95c0-1.13,1.27-1.55,1.27-2.82s-1.83-1.14-2.82-.29-1.28,3.4-1.28,3.4-1.56-2.65-2.4-4.53c-.75-1.68-1.79-4.58-3.2-5s-1.35,1.32-1.21,1.74a17.76,17.76,0,0,0,.88,2.41c.33.65,1,2.55,1,2.55s-2-1.56-2.69-1.56a1,1,0,0,0-.85,1.56s-1.7.71-1.27,1.84.56,1.55.56,1.55-.42.57,0,2,2.27,3.82,3,5a6.09,6.09,0,0,0,1.56,1.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,242.77a11.39,11.39,0,0,0,1.57,1.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.25,246.16a6.44,6.44,0,0,0,1,1.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.76,260.31l-2.49-5.44a6.31,6.31,0,0,1,4.26-2.64c3.08-.59,3.52,0,3.52,0l1.62,5.58S359.38,258.25,357.76,260.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.33,289.16l-19.59-18.87s-4.55-7.78-5.72-10.57-2.79-3.53-5.44-3.23-5,3.08-5,5.14c0,1.17,3,8.22,5.74,14.31.14.43,4,12.35,6.17,13.22s25.15,24.71,25.15,24.71L402,292.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,309.72c1.22,11.59.73,42,.73,44.07,0,2.5-.15,2.64.73,3.38s9.23,1,17.31.89,18.2-1.81,18.94-1.81a3.8,3.8,0,0,0,2.94-1.76c.48-.73,5.26-30.7,6.66-44.46,1.16-11.38-1.5-13.83-1.43-14.09.15-.59-11.61-4.85-12.64-5.14s-6.9-4.26-20.12.73c0,0-5.43-1.72-7.4-.87,0,0,3.81,7.62.95,14.93S390,309.72,390,309.72Z",
    style: {
      fill: "#EFDECB",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.87,338.29c0,1.86,0,3.64,0,5.29,5.37-.54,22.31-2.06,42.15-2.08.26-1.67.54-3.43.81-5.26C414.05,336.22,397,337.69,390.87,338.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.83,330.42c6.34-.64,26.25-2.42,44.06-1.37,1-7,2-14.07,2.46-19,1.16-11.38-1.5-13.83-1.43-14.09s-3.09-1.62-6.28-2.84c1.25,2.14,3.38,7.08,3.18,15.69-.14,5.75-.63,11-1.11,14.83-7.66-.31-15.44-.17-22.28.15.12-3,.15-6.58.07-10.59A63.54,63.54,0,0,0,405,290.91c-.59.19-1.17.39-1.79.62a30.16,30.16,0,0,0-4.08-.95,58.7,58.7,0,0,1,5.16,22.7c.08,4.14,0,7.74-.1,10.77-5.86.36-10.61.8-13.38,1.09C390.79,326.88,390.81,328.65,390.83,330.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.23,321.47c-4.2,6-10.84,14.84-16,18.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.32,315.32s-.76,1.22-2,3.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.16,336.2a71.59,71.59,0,0,1-10.57,7.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.36,432a19.09,19.09,0,0,0,5.46,4c0-.43,0-.83,0-1.2,0-6.17-4.85-44.41-4.41-53.81.08-1.71.24-3.65.44-5.71a7.31,7.31,0,0,0-.59-1.19,106.12,106.12,0,0,1-6.46-11.61l7.63,7.3c.06-.55.13-1.11.19-1.66-2-3.65-4.7-8.66-4.88-10.19l-9,4.85s-1.18,34.86-1,46.32c0,0,.87,4,2,9.19C418.52,424.63,423.48,429.05,426.36,432Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.17,452.73a34.7,34.7,0,0,1-.08,6.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.52,444.31c.13,1.95.26,3.68.37,5.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.72,367.94c.36,14.72,1.24,47.05,2,54.26.57,5.22,1.09,12.44,1.52,18.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkInProgressIllustration);
export default __webpack_public_path__ + "static/media/work-in-progress-illustration.ea4cbc284723688637842a35703356c3.svg";
export { ForwardRef as ReactComponent };